export enum BrandReference {
    Absolut_Elyx,
    Havana_Club_3_years,
    Havana_Club_5_years,
    Havana_Club_7_years
}